/**
 * The hero's centrepiece.
 *
 * Replaces the source design's `MascotPlaceholder`, whose commissioned
 * illustration does not exist. A dashed "[ mascot: … ]" box is the most
 * prominent element on the page; a real screen is better than an apology.
 *
 * Captured from this app's own encounters list on the Warm Clinic palette, so
 * it stays in step with the product rather than showing the pre-fork UI the
 * older files in public/screenshots still do.
 *
 * The card's oxblood dome *frames* the shot rather than clipping it. Clipping a
 * screenshot to a dome eats the top corners, which on a table view is exactly
 * where the column headers and the first stat card live. Sitting it in a plain
 * rounded panel with the arch above keeps the dome as the shape of the section
 * and leaves the screen readable.
 *
 * Top-anchored, because the interesting half of a table is its header and first
 * rows; `object-cover` would otherwise centre-crop them away.
 */
export function AppPreview() {
    return (
        <div className="mt-[12%] w-full flex-1 overflow-hidden rounded-[14px] border border-border bg-brand-paper shadow-medium">
            <img
                width={2312}
                height={1664}
                loading="eager"
                src="/screenshots/app-encounters.png"
                className="h-full w-full object-cover object-top"
                alt="The MohairNotes encounters list: patients, clinicians, visit type and note status in one table"
            />
        </div>
    );
}
